import { render, staticRenderFns } from "./UploadManager.vue?vue&type=template&id=253009c4&scoped=true&"
import script from "./UploadManager.vue?vue&type=script&lang=js&"
export * from "./UploadManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253009c4",
  null
  
)

export default component.exports